(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[492],{

/***/ 9608:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[slug]",
      function () {
        return __webpack_require__(3816);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iz": function() { return /* binding */ postHeroImageSize; },
/* harmony export */   "Oz": function() { return /* binding */ postSocialImageUrl; },
/* harmony export */   "zx": function() { return /* binding */ postHeroImageDimensions; }
/* harmony export */ });
/* unused harmony export postHeroImageUrl */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1614);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6089);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_favicon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5235);
/* harmony import */ var _lib_sanity__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5118);
/* harmony import */ var _vimeo__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7955);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}






var postHeroImageDimensions = [
    1600,
    800
];
var _postHeroImageDimensions = _slicedToArray(postHeroImageDimensions, 2), width = _postHeroImageDimensions[0], height = _postHeroImageDimensions[1];
var postHeroImageSize = {
    width: width,
    height: height
};
var postHeroImageUrl = function(img) {
    return urlForImage(img).width(width).height(height).url();
};
var postSocialImageUrl = function(socialImg, heroImg) {
    return (socialImg === null || socialImg === void 0 ? void 0 : socialImg.asset) ? (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_4__/* .urlForImage */ .iQ)(socialImg).url() : (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_4__/* .urlForImage */ .iQ)(heroImg).width(width).height(height).url();
};
var formatDate = function(date) {
    return new Date("".concat(date, "T00:00:00Z")).toLocaleDateString(undefined, {
        day: "numeric",
        month: "long",
        year: "numeric",
        timeZone: "UTC"
    });
};
function BlogPostHeader(param) {
    var post = param.post, Heading = param.heading;
    var ref;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            post.customerImg && post.customerName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                role: "img",
                "aria-label": "".concat(post.customerName, " + Watershed logos"),
                className: "jsx-19a20b0a40d53184" + " " + "customer-header",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_4__/* .urlForImage */ .iQ)(post.customerImg).width(180).height(42).url(),
                        alt: post.customerName,
                        height: 42,
                        width: 180,
                        objectFit: "contain",
                        objectPosition: "right center",
                        "aria-hidden": true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        "aria-hidden": true,
                        className: "jsx-19a20b0a40d53184",
                        children: "+"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            width: 90,
                            lineHeight: 0 /* optical alignment */ 
                        },
                        "aria-hidden": true,
                        className: "jsx-19a20b0a40d53184",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_favicon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            width: 42,
                            height: 42
                        })
                    })
                ]
            }),
            post.videoPlayerUrl && Heading === "h1" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "jsx-19a20b0a40d53184" + " " + "hero-container",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vimeo__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    video: post.videoPlayerUrl
                })
            }) : ((ref = post.heroImg) === null || ref === void 0 ? void 0 : ref.asset) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "jsx-19a20b0a40d53184" + " " + "hero-container",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpread({
                    src: (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_4__/* .urlForImage */ .iQ)(post.heroImg).fit("crop").crop("focalpoint").width(1600).height(800).url(),
                    alt: post.heroImg.alt
                }, postHeroImageSize, {
                    className: "hero-image"
                }))
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Heading, {
                className: "jsx-19a20b0a40d53184" + " " + "blog-post-title",
                children: post.title
            }),
            post.updatedDate ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "jsx-19a20b0a40d53184" + " " + "blog-post-date",
                children: [
                    "Published ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
                        dateTime: post.date,
                        className: "jsx-19a20b0a40d53184",
                        children: formatDate(post.date)
                    }),
                    " \u2022 ",
                    "Last updated",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
                        dateTime: post.updatedDate,
                        className: "jsx-19a20b0a40d53184",
                        children: formatDate(post.updatedDate)
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("time", {
                dateTime: post.date,
                className: "jsx-19a20b0a40d53184" + " " + "blog-post-date",
                children: formatDate(post.date)
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "19a20b0a40d53184",
                children: ".customer-header.jsx-19a20b0a40d53184{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;margin:0 auto 48px}.customer-header.jsx-19a20b0a40d53184 span.jsx-19a20b0a40d53184{color:#222c49;opacity:.25;padding:0 24px;font-size:32px}.hero-container.jsx-19a20b0a40d53184{background-color:#edf1f5;max-width:100vw;margin:0 -12px 24px;line-height:0}.hero-image.jsx-19a20b0a40d53184{width:100%;height:100%}@media screen and (min-width:520px){.customer-header.jsx-19a20b0a40d53184{margin:32px auto 80px}.hero-container.jsx-19a20b0a40d53184{margin:0 -48px 48px}.hero-container.jsx-19a20b0a40d53184:first-child{margin:-48px -48px 48px}}"
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["ZP"] = (BlogPostHeader);


/***/ }),

/***/ 4747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PreviewBanner; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1614);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1770);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(125);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);




function PreviewBanner() {
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)(), slug = ref.query.slug;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "jsx-1b43c4507942d1e4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "jsx-1b43c4507942d1e4",
                children: slug ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        "You\u2019re previewing an ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                            className: "jsx-1b43c4507942d1e4",
                            children: "unpublished draft"
                        })
                    ]
                }) : "You\u2019re in preview mode, seeing unpublished posts"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                href: "/api/exit-preview",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    className: "jsx-1b43c4507942d1e4" + " " + "button",
                    children: "Exit preview"
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "1b43c4507942d1e4",
                children: "section.jsx-1b43c4507942d1e4{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;gap:16px;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center;background-color:#fff8c4;color:#927344;padding:16px;font-size:16px;margin-bottom:24px}.button.jsx-1b43c4507942d1e4{background-color:#f63;color:#fff!important;line-height:1.25}@media(max-width:520px){span.jsx-1b43c4507942d1e4{margin:8px 0}}"
            })
        ]
    });
};


/***/ }),

/***/ 3940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1614);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(125);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1770);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7448);





function Demobar(param) {
    var _narrow = param.narrow, narrow = _narrow === void 0 ? false : _narrow, noMargin = param.noMargin, copy = param.copy;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        style: {
            margin: noMargin ? 0 : "".concat(narrow ? 0 : 24, "px auto 24px")
        },
        className: next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
            [
                "7241d4a1ee4dc5d0",
                [
                    narrow ? _constants__WEBPACK_IMPORTED_MODULE_4__/* .NARROW_WIDTH */ .V : _constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_WIDTH */ .d
                ]
            ]
        ]),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                    [
                        "7241d4a1ee4dc5d0",
                        [
                            narrow ? _constants__WEBPACK_IMPORTED_MODULE_4__/* .NARROW_WIDTH */ .V : _constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_WIDTH */ .d
                        ]
                    ]
                ]),
                children: copy ? copy : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        "Ready to build a high-impact climate",
                        " ",
                        locale === "en-GB" ? "programme" : "program",
                        "?"
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/demo",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    "data-track-id": "demobar.contact",
                    className: next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default().dynamic([
                        [
                            "7241d4a1ee4dc5d0",
                            [
                                narrow ? _constants__WEBPACK_IMPORTED_MODULE_4__/* .NARROW_WIDTH */ .V : _constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_WIDTH */ .d
                            ]
                        ]
                    ]) + " " + "button primary",
                    children: "Request a demo"
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "7241d4a1ee4dc5d0",
                dynamic: [
                    narrow ? _constants__WEBPACK_IMPORTED_MODULE_4__/* .NARROW_WIDTH */ .V : _constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_WIDTH */ .d
                ],
                children: "section.__jsx-style-dynamic-selector{width:100%;max-width:".concat(narrow ? _constants__WEBPACK_IMPORTED_MODULE_4__/* .NARROW_WIDTH */ .V : _constants__WEBPACK_IMPORTED_MODULE_4__/* .MAX_WIDTH */ .d, "px;padding:8px 24px;-webkit-border-radius:16px;-moz-border-radius:16px;border-radius:16px;background-color:#e0f0ff;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-webkit-justify-content:space-between;-moz-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap}@media(min-width:820px){section.__jsx-style-dynamic-selector{padding:32px 48px}}h2.__jsx-style-dynamic-selector{font-size:24px;color:#294aae;-webkit-box-flex:1;-webkit-flex-grow:1;-moz-box-flex:1;-ms-flex-positive:1;flex-grow:1;margin:16px 32px 16px 0;z-index:0}.button.__jsx-style-dynamic-selector{display:inline-block;font-size:18px;margin-top:16px;margin-bottom:16px}")
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Demobar);


/***/ }),

/***/ 5118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iQ": function() { return /* binding */ urlForImage; }
/* harmony export */ });
/* unused harmony exports imageBuilder, usePreviewSubscription, client, previewClient, getClient */
/* harmony import */ var next_sanity__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9927);
/* harmony import */ var _sanity_image_url__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8687);
/* harmony import */ var _sanity_image_url__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_sanity_image_url__WEBPACK_IMPORTED_MODULE_0__);
/* provided dependency */ var process = __webpack_require__(2921);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


var config = {
    dataset: "production",
    projectId: "3ogo9b9g",
    useCdn: "production" !== "production",
    // useCdn == true gives fast, cheap responses using a globally distributed cache.
    // When in production the Sanity API is only queried on build-time, and on-demand when responding to webhooks.
    // Thus the data need to be fresh and API response time is less important.
    // When in development/working locally, it's more important to keep costs down as hot reloading can incurr a lot of API calls
    // And every page load calls getStaticProps.
    // To get the lowest latency, lowest cost, and latest data, use the Instant Preview mode
    apiVersion: "2022-01-11"
};
var imageBuilder = _sanity_image_url__WEBPACK_IMPORTED_MODULE_0___default()(config);
var urlForImage = function(source) {
    return imageBuilder.image(source).auto("format").fit("max");
};
var usePreviewSubscription = (0,next_sanity__WEBPACK_IMPORTED_MODULE_1__/* .createPreviewSubscriptionHook */ .KF)(config);
var client = (0,next_sanity__WEBPACK_IMPORTED_MODULE_1__/* .createClient */ .eI)(config);
var previewClient = (0,next_sanity__WEBPACK_IMPORTED_MODULE_1__/* .createClient */ .eI)(_objectSpread({}, config, {
    useCdn: false,
    token: process.env.SANITY_API_TOKEN
}));
var getClient = function() {
    var usePreview = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return usePreview ? previewClient : client;
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (client)));


/***/ }),

/***/ 3816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Page; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4637);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1614);
/* harmony import */ var next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_meta__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1797);
/* harmony import */ var _components_navbar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9106);
/* harmony import */ var _components_blog_header__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3133);
/* harmony import */ var _components_blog_preview_banner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4747);
/* harmony import */ var _components_toc__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7350);
/* harmony import */ var _components_footer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4898);
/* harmony import */ var _components_demobar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3940);
/* harmony import */ var _lib_mdx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8905);
/* harmony import */ var next_mdx_remote__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5842);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}











var __N_SSG = true;
function Page(param) {
    var preview = param.preview, post = param.post;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    var ref8, ref9, _updatedDate;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_meta__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: post.title,
                name: "Watershed Blog",
                description: post.excerpt,
                image: ((ref = post.socialImg) === null || ref === void 0 ? void 0 : ref.asset) || ((ref1 = post.heroImg) === null || ref1 === void 0 ? void 0 : ref1.asset) ? (0,_components_blog_header__WEBPACK_IMPORTED_MODULE_4__/* .postSocialImageUrl */ .Oz)(post.socialImg, post.heroImg) : undefined,
                children: [
                    !((ref2 = post.socialImg) === null || ref2 === void 0 ? void 0 : ref2.asset) && ((ref3 = post.heroImg) === null || ref3 === void 0 ? void 0 : ref3.asset) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:image:width",
                                content: _components_blog_header__WEBPACK_IMPORTED_MODULE_4__/* .postHeroImageDimensions[0].toString */ .zx[0].toString(),
                                className: "jsx-e6afb5760d1bec37"
                            }, "og_img_width"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:image:height",
                                content: _components_blog_header__WEBPACK_IMPORTED_MODULE_4__/* .postHeroImageDimensions[1].toString */ .zx[1].toString(),
                                className: "jsx-e6afb5760d1bec37"
                            }, "og_img_height")
                        ]
                    }),
                    ((ref8 = (ref4 = post.socialImg) === null || ref4 === void 0 ? void 0 : ref4.alt) !== null && ref8 !== void 0 ? ref8 : (ref5 = post.heroImg) === null || ref5 === void 0 ? void 0 : ref5.alt) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:alt",
                        content: (ref9 = (ref6 = post.socialImg) === null || ref6 === void 0 ? void 0 : ref6.alt) !== null && ref9 !== void 0 ? ref9 : (ref7 = post.heroImg) === null || ref7 === void 0 ? void 0 : ref7.alt,
                        className: "jsx-e6afb5760d1bec37"
                    }, "og_img_alt"),
                    post.videoDirectUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:card",
                                content: "player",
                                className: "jsx-e6afb5760d1bec37"
                            }, "tw_card"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:player",
                                content: post.videoDirectUrl,
                                className: "jsx-e6afb5760d1bec37"
                            }, "tw_player"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:video",
                                content: post.videoDirectUrl,
                                className: "jsx-e6afb5760d1bec37"
                            }, "og_video"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:video:secure_url",
                                content: post.videoDirectUrl,
                                className: "jsx-e6afb5760d1bec37"
                            }, "og_video_url"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:video:type",
                                content: "video/mp4",
                                className: "jsx-e6afb5760d1bec37"
                            }, "og_video_type"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:video:width",
                                content: "1920",
                                className: "jsx-e6afb5760d1bec37"
                            }, "og_video_width"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:video:height",
                                content: "1080",
                                className: "jsx-e6afb5760d1bec37"
                            }, "og_video_height"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "tw:player:width",
                                content: "1920",
                                className: "jsx-e6afb5760d1bec37"
                            }, "tw_video_width"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "tw:player:height",
                                content: "1080",
                                className: "jsx-e6afb5760d1bec37"
                            }, "tw_video_height")
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "https://schema.org/",
                                "@type": "BlogPosting",
                                mainEntityOfPage: {
                                    "@type": "WebPage",
                                    "@id": "https://watershed.com/blog/".concat(post.slug)
                                },
                                image: post.heroImg ? _objectSpread({
                                    "@type": "ImageObject",
                                    url: (0,_components_blog_header__WEBPACK_IMPORTED_MODULE_4__/* .postSocialImageUrl */ .Oz)(post.socialImg, post.heroImg),
                                    description: post.heroImg.alt
                                }, _components_blog_header__WEBPACK_IMPORTED_MODULE_4__/* .postHeroImageSize */ .Iz) : undefined,
                                author: {
                                    "@type": "Person",
                                    name: "Watershed team"
                                },
                                datePublished: post.date,
                                dateModified: (_updatedDate = post.updatedDate) !== null && _updatedDate !== void 0 ? _updatedDate : post.date,
                                headline: post.title,
                                description: post.excerpt,
                                url: "https://watershed.com/blog/".concat(post.slug),
                                publisher: {
                                    "@type": "Organization",
                                    name: "Watershed",
                                    url: "https://watershed.com",
                                    logo: {
                                        "@type": "ImageObject",
                                        url: "https://watershed.com/favicon.svg"
                                    }
                                }
                            })
                        },
                        className: "jsx-e6afb5760d1bec37"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_navbar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {}),
            preview && post._id.startsWith("drafts.") && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_blog_preview_banner__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: "jsx-e6afb5760d1bec37" + " " + ((post.toc ? "with-toc" : "") || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
                        className: "jsx-e6afb5760d1bec37" + " " + "blog-post",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_blog_header__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                post: post,
                                heading: "h1"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_mdx_remote__WEBPACK_IMPORTED_MODULE_10__/* .MDXRemote */ .R, _objectSpread({}, post.contentSource, {
                                components: _lib_mdx__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z
                            }))
                        ]
                    }),
                    Array.isArray(post.toc) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_toc__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        items: post.toc
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "jsx-e6afb5760d1bec37" + " " + "container",
                children: post.slug !== "watershed-launch" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_demobar__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    narrow: !post.toc
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_footer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_dist_shared_lib_styled_jsx__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "e6afb5760d1bec37",
                children: "article.jsx-e6afb5760d1bec37 strong{color:#222c49}@media(min-width:820px){.with-toc.jsx-e6afb5760d1bec37{display:grid;grid-gap:24px;grid-template-columns:2fr 1fr;-webkit-box-align:start;-webkit-align-items:start;-moz-box-align:start;-ms-flex-align:start;align-items:start;padding:24px 16px}}"
            })
        ]
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [109,89,554,174,854,33,774,888,179], function() { return __webpack_exec__(9608); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);